import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const FAQS = [
  {
    q: "Cabinetul are contract cu Casa de Asigurări de Sănătate?",
    a: "Da. Cabinetul Ro-Dental se află în relație contractuală activă cu Casa de Asigurări de Sănătate Cluj. Programările pentru servicii decontate sunt: Luni 10:00–13:00, Marți 09:00–12:00, Miercuri 14:00–17:00, Joi 10:00–13:00, Vineri 10:00–13:00.",
  },
  {
    q: "Cum pot face o programare?",
    a: "Cea mai eficientă modalitate este telefonic, la numărul 0721 592 343. De asemenea, puteți completa formularul online — vă vom contacta pentru confirmarea exactă a intervalului orar.",
  },
  {
    q: "Care sunt tarifele?",
    a: "Tarifele variază în funcție de complexitatea fiecărui caz. La consultația inițială primiți un plan de tratament detaliat și un deviz transparent, înainte de începerea oricărei intervenții. Pentru pacienții asigurați, anumite servicii sunt decontate prin Casa de Asigurări de Sănătate.",
  },
  {
    q: "Tratați și pacienți pediatrici?",
    a: "Da. Acordăm o atenție deosebită stomatologiei pediatrice, abordând fiecare copil cu blândețe și răbdare, pentru a construi o relație de încredere cu medicul stomatolog încă de la prima vizită.",
  },
  {
    q: "Ce echipamente și materiale folosiți?",
    a: "Utilizăm materiale și echipamente moderne, certificate, în cadrul unor protocoale stricte de igienă și sterilizare conforme cu standardele în vigoare.",
  },
  {
    q: "Tratamentele sunt dureroase?",
    a: "Disconfortul este redus la minim prin utilizarea anesteziei locale eficiente și prin tehnici moderne de tratament. Vă explicăm fiecare etapă pentru a vă oferi liniște și încredere pe parcursul intervenției.",
  },
  {
    q: "Pot să mă prezint în regim de urgență?",
    a: "Vă rugăm să ne contactați telefonic. În măsura posibilităților, vă primim în cel mai scurt timp, în special în cazurile de durere acută.",
  },
];

export default function FAQ() {
  return (
    <div>
      <section className="bg-soft-cream">
        <div className="max-w-7xl mx-auto container-x py-16">
          <p className="text-brand-red font-semibold text-xs uppercase tracking-[0.2em] mb-3">Întrebări frecvente</p>
          <h1 className="font-display font-extrabold text-brand-navy text-4xl sm:text-5xl lg:text-6xl tracking-tight">Răspunsuri la întrebările dumneavoastră</h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto container-x py-14">
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="bg-white border border-brand-yellow/40 rounded-2xl px-5 shadow-sm">
              <AccordionTrigger className="text-left font-display font-bold text-brand-navy text-base hover:no-underline" data-testid={`faq-q-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="text-brand-navy/80 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
